import React from 'react'
import PropTypes from 'prop-types'

import currencyFormat from 'functions/currencyFormat'

import ContentHolder from '../../ui/ContentHolder'

import windowImage from '../../assets/window.jpg'
import styles from './styles.scss'

const PriceRecommendation = (props) => {
  const {
    campaign: { address, suburb_name },
    campaignProposal: {
      list_price_max, list_price_min,
    },
  } = props

  if (!list_price_min || !list_price_max) return null

  return (
    <div className={styles.root} style={{ backgroundImage: `url(${windowImage})` }}>
      <ContentHolder>
        <div className={styles.content}>
          <h4>Our price recommendation for:</h4>

          <h1 style={{ marginTop: 15, lineHeight: '1.3' }}>
            {address}, {suburb_name}
          </h1>

          <p className={styles.intro}>
            To offer an accurate price for your property we have to take into account the current nationwide real estate
            climate, and competing properties available in the local market as well as your property&apos;s features and
            location.<br />
            <br />
            Based on all of our research and market knowledge it is our opinion that the current market value for{' '}
            {address}, {suburb_name} lies in the range of:
          </p>

          <span className={styles.priceLarge}>
            {currencyFormat(list_price_min, '$0,0')} - {currencyFormat(list_price_max, '$0,0')}
          </span>
        </div>
      </ContentHolder>
    </div>
  )
}

PriceRecommendation.propTypes = {
  campaign: PropTypes.object.isRequired,
  campaignProposal: PropTypes.object.isRequired,
}

export default PriceRecommendation
